const Model = {
    PAYMENT_REQUEST : JSON.stringify({ "type": "creditCard", "parameters": [{ "title": "Please provide your token number." }] }),
    FORM_PAYMENT : {
        TYPE : 'FORM',
        REQUEST : "PAYMENT_REQUEST"
    },
    URL_PAYMENT : {
        TYPE : 'URL',
        REQUEST : "https://www.searspartsdirect.com/get-code"
    },
    PAYMENT_OBJECT : () => {
            return {
                contactId: "", 
                ccDetails: {},
                message : "",
                type : "",
                status : ""
            }
    }
}


export default Model;